module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-SemiboldItalic-7670f1ce.eot";